import type React from 'react';

import { GoToStreamGroupLink } from '@vlabs/monokit/features/go-to-stream-group/GoToStreamGroupLink';
import type { GroupId } from '@vlabs/api/artemy/model';

import st from './PermissionTagGroupListItem.module.sass';

interface PermissionTagGroupListItemProps {
  groupId: GroupId;
  actions?: React.ReactNode;
}

function PermissionTagGroupListItem({
  groupId,
  actions = undefined,
}: PermissionTagGroupListItemProps): React.JSX.Element {
  return (
    <div className={st.Root}>
      <GoToStreamGroupLink groupId={groupId} />
      {actions}
    </div>
  );
}

export { PermissionTagGroupListItem };
